import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCampaign } from "./CampaignContext";

export default function NavBar() {
  const { pathname } = useLocation();
  const nav = useNavigate();
  const { current, error, warnings, saveStatus, flush, downloadRecovery, loadLatest } = useCampaign();

  const hasCampaign = Boolean(current?.settlementName?.trim());

  const linkStyle = (path) => ({
    marginRight: 12,
    textDecoration: pathname === path ? "underline" : "none",
  });

  return (
    <div
      style={{
        padding: 12,
        borderBottom: "1px solid #ddd",
        display: "flex",
        alignItems: "center",
        gap: 8,
        flexWrap: "wrap",
      }}
    >
      <div role="status" style={{ width: "100%", color: error ? "crimson" : "inherit" }}>
        {saveStatus} {error && <><span role="alert">{error}</span> <button onClick={downloadRecovery}>Download recovery copy</button> <button onClick={() => loadLatest().catch(() => {})}>Load latest saved version</button></>}
        {warnings.map(w => <p role="alert" key={w}>{w}</p>)}
      </div>
      <button onClick={async () => { try { await flush(); await fetch("/api/auth/logout", { method: "POST", headers: { "Content-Type": "application/json" }, body: "{}" }); window.location.assign("/"); } catch {} }}>Log out</button>
      {Object.keys(localStorage).some(key => key.startsWith("kdm_recovery__")) && <button onClick={downloadRecovery}>Download archived recovery copies</button>}
      <div style={{ marginRight: 16, fontWeight: 700 }}>Kingdom Death Manager</div>

      <Link to="/" style={linkStyle("/")}>Home</Link>

      {/* Only show these when a campaign is loaded */}
      {hasCampaign ? (
        <>
          <Link to="/settlement" style={linkStyle("/settlement")}>Settlement</Link>
          <Link to="/departing" style={linkStyle("/departing")}>Departing Survivors</Link>
          <Link to="/timeline" style={linkStyle("/timeline")}>Timeline</Link>
          <Link to="/compendium" style={linkStyle("/compendium")}>Compendium</Link>
        </>
      ) : null}

      <div style={{ marginLeft: "auto", opacity: 0.75 }}>
        {hasCampaign ? `Loaded: ${current.settlementName}` : "No campaign loaded"}
        {!hasCampaign ? (
          <button style={{ marginLeft: 10 }} onClick={() => nav("/")}>
            Go Home
          </button>
        ) : null}
      </div>
    </div>
  );
}
